import { lazy, Suspense } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { decryptData } from "src/utils/decryptcookie";
import LoadingScreen from "../../../components/LoadingScreen.js";
import AuthGuard from "../../../guards/AuthGuard.js";
import DashboardLayout from "../../../layouts/dashboard/index.js";

const Loadable = (Component) => (props) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pathname } = useLocation();
  const isDashboard = pathname.includes("/dashboard");

  return (
    <Suspense
      fallback={
        <LoadingScreen
          sx={{
            ...(!isDashboard && {
              top: 0,
              left: 0,
              width: 1,
              zIndex: 9999,
              position: "fixed",
            }),
          }}
        />
      }
    >
      <Component {...props} />
    </Suspense>
  );
};

const BookingTablePage = Loadable(
  lazy(() => import("src/pages/Bookings/BookingTablePage"))
);
const EditBookingDetails = Loadable(
  lazy(() => import("src/pages/InhouseAgents/EditBookingDetails"))
);
const TransferPnrList = Loadable(
  lazy(() => import("src/components/_dashboard/transferPnr/TransferPnrList.js"))
);

const InhouseAgentsPNR = Loadable(
  lazy(() => import("src/components/_dashboard/transferPnr/InhouseAgentsPNR"))
);

const AgentToCheckRules = Loadable(
  lazy(() =>
    import("src/components/_dashboard/adminPages/AdminFareRuleChooseAgent.js")
  )
);
const BulkData = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/Bulkdata.js"))
);
const ScrappyUser = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/AddScrappyUser.js"))
);
const ViewScrappyUser = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/ViewScappyUser.js"))
);
const GetMeta = Loadable(lazy(() => import("src/pages/Meta-mange.js")));
const AppliedRule = Loadable(
  lazy(() => import("src/pages/FareRule/ExistingFareRule.js"))
);
const ViewAllData = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/ViewData.js"))
);
const AddIternary = Loadable(
  lazy(() => import("src/pages/ScrappingManegment/AddIternary.js"))
);

// const CreateBooking = Loadable(lazy(() => import("../../pages/BookingApi")));
const Cancellations = Loadable(
  lazy(() => import("src/pages/cancellations.js"))
);

const Amendments = Loadable(
  lazy(() => import("src/pages/InhouseAgents/Amendments.js"))
);

export const InHouseRoutes = () => {
  const parsedData = decryptData("_b60-g6fr_plus");

  return {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),

    children: [
      {
        path: "/dashboard",
        element: (
          <AuthGuard>
            <DashboardLayout />
          </AuthGuard>
        ),

        children: [
          {
            path: "",
            element: (
              <Navigate
                to={
                  parsedData === null
                    ? "/dashboard"
                    : parsedData?.role === "admin"
                    ? "/dashboard/manager-info"
                    : parsedData?.role === "manager"
                    ? "/dashboard/add-info"
                    : parsedData?.role === "agent"
                    ? "/dashboard/sub-agent-info"
                    : parsedData?.role === "sub-agent"
                    ? "/dashboard/bookingsHistory"
                    : parsedData?.role === "accounts"
                    ? "/dashboard/accounts-all-requests"
                    : parsedData?.role === "inhouseAgents"
                    ? "/dashboard/all-booking-details"
                    : "/dashboard"
                }
                replace
              />
            ),
          },

          { path: "transferred-pnr-list", element: <TransferPnrList /> },
          { path: "cancellations", element: <Cancellations /> },
          { path: "checkAgentRules", element: <AgentToCheckRules /> },
          { path: "scrap-all-data", element: <ViewAllData /> },
          { path: "add-Iternary", element: <AddIternary /> },
          { path: "add-bulk-data", element: <BulkData /> },
          { path: "add-scrappy-user", element: <ScrappyUser /> },
          { path: "view-scrappy-user", element: <ViewScrappyUser /> },
          { path: "get-meta", element: <GetMeta /> },
          { path: "all-booking-details", element: <BookingTablePage /> },
          { path: "edit-booking-details", element: <EditBookingDetails /> },
          { path: "get-all-amendments", element: <Amendments /> },
          { path: "inhouseagents-pnr-list", element: <InhouseAgentsPNR /> },
        ],
      },
    ],
  };
};
